import { useRef, useEffect } from 'react';
import { TerminalWindow } from '@phosphor-icons/react';

export default function ByteLog({ log }) {
    const ref = useRef(null);
    useEffect(() => { ref.current?.scrollTo(0, ref.current.scrollHeight); }, [log]);
    if (log.length === 0) return null;
    return (
        <div className="mt-3 rounded-lg bg-black/60 border border-white/10 overflow-hidden">
            <div className="flex items-center gap-2 px-3 py-1.5 border-b border-white/10 bg-white/5">
                <TerminalWindow size={12} className="text-primary" />
                <span className="text-[10px] font-mono text-muted-foreground">Serial Monitor</span>
            </div>
            <div ref={ref} className="p-2 max-h-36 overflow-y-auto font-mono text-[10px] space-y-0.5" data-testid="byte-log">
                {log.map((entry, i) => (
                    <div key={`${entry.time}-${entry.dir}-${i}`} className={entry.dir === 'tx' ? 'text-primary' : 'text-electric-blue'}>
                        <span className="text-muted-foreground">{entry.time} </span>
                        <span className="font-bold">{entry.dir === 'tx' ? 'TX' : 'RX'}</span>{' '}
                        <span>{entry.hex}</span>
                        {entry.label && <span className="text-muted-foreground ml-2">// {entry.label}</span>}
                    </div>
                ))}
            </div>
        </div>
    );
}
